import React, { useState, useEffect } from 'react';
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import { IconButton/* , ListItemAvatar */ } from "@material-ui/core";
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';

import AppBar from '@material-ui/core/AppBar';
import klogo from "../../img/Komatsu_white.png";
import Typography from '@material-ui/core/Typography';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import Collapse from '@material-ui/core/Collapse';
import FolderIcon from '@material-ui/icons/Folder';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import BusinessIcon from '@material-ui/icons/Business';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonAddIcon from '@material-ui/icons/PersonAdd';


const drawerWidth = 240;
const styles = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    navmenuimg: {
        "@media (max-width: 767px)": {
            maxWidth: "145px",
            height: "auto"
        },
    },
    navmenuh5: {
        "@media (max-width: 767px)": {
            fontSize: "12px !important",
            paddingLeft: "0 !important"
        },
    },
    navmenuh6: {
        "@media (max-width: 767px)": {
            fontSize: "12px !important"
        },
    },

    menuButton: {
        marginRight: theme.spacing(2),
        "@media (max-width: 767px)": {
            marginRight: "0px !important"
        },
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
});

const NavMenu = ({ classes, theme, isOpen, handleSetOpen, currentUser, hasAccess }) => {
    const navigate = useNavigate();
    const currentUserAuth = useSelector(state => state.auth);

    const [adminMenuOpen, setAdminMenuOpen] = useState(false);
      const [reportMenuOpen, setReportMenuOpen] = useState(false);

    const [addHome, setAddHome] = useState(false);
    const [userAdmin, setUserAdmin] = useState(false);
    const [externalUserAdmin, setExternalUserAdmin] = useState(false);
    const [addExternalUser, setAddExternalUser] = useState(false);
    const [addAccessRequest, setAddAccessRequest] = useState(false);
    const [addCompany, setAddCompany] = useState(false);
    const [userfile, setUserFile] = useState(false);
    const [moderateFiles, setModerateFiles] = useState(false);
    const [manageCompanies, setManageCompanies] = useState(false);
  const [activeuser, setactiveuser] = useState(false);
  

    useEffect(() => {
        if (currentUserAuth.user.userPermissions !== undefined) {

            try {
                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Home").state) {
                    setAddHome(true);
                }

                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Admin Users").state) {
                    setUserAdmin(true);
                }

                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "File Moderator").state) {
                    setModerateFiles(true);
                }

                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Add External Users").state) {
                    setAddExternalUser(true);
                }

                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Admin Companies").state) {
                    setManageCompanies(true);
                }

                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Access State").state) {
                    setAddAccessRequest(true);
                }
                 if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Access State").state) {
                    setAddCompany(true);
                }
                  if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Access State").state) {
                    setUserFile(true);
                }


                if (currentUserAuth.user.userPermissions.find(p => p.permission.permissionName === "Approve External Users").state) {
                    setExternalUserAdmin(true);
                }
                
            } catch (error) {
                console.log(error);
            }
        }
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: isOpen,
                })}
                color="primary"
            >
                <Toolbar>
                    {hasAccess &&
                        <IconButton
                            color="inherit"
                            aria-label="open menu"
                            onClick={() => handleSetOpen(true)}
                            edge="start"
                            className={clsx(classes.menuButton, isOpen && classes.hide)}
                        >
                            <MenuIcon />
                        </IconButton>
                    }
                     <IconButton
                             color="inherit"
                             aria-label="home"
                             onClick={() => navigate("/")}
                            style={{ marginLeft: "-16px"}}
                       >
                        <HomeIcon className={classes.homeIcon}/>
                    </IconButton>

                    <img src={klogo} alt="logo" height="70px" className={classes.navmenuimg} style={{ cursor: "pointer" }} onClick={() => navigate("/")} />
                    <Typography variant="h5" color="inherit" className={classes.navmenuh5} style={{ paddingLeft: "10px", fontSize: '1.25vw' }}>
                        KFTP
                    </Typography>
                  <Typography variant="h5" color="inherit" style={{ paddingLeft: "10px", fontSize: '1.25vw' }}>
                     Komatsu File Transfer Portal
                    </Typography>                   
                    {currentUserAuth.aadResponse &&
                        <Typography variant="h6" className={classes.navmenuh6} style={{ marginLeft: "auto", marginRight: '10px', fontSize: '1vw' }} color="inherit">{currentUserAuth.aadResponse.account.name}</Typography>
                    }
                </Toolbar>
            </AppBar>
            {hasAccess &&
                <span>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={isOpen}
                        classes={{ paper: classes.drawerPaper }}
                    >
                        <div className={classes.drawerHeader}>
                            <IconButton onClick={() => handleSetOpen(false)}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </div>
                        <Divider />
						<div className={classes.ListDiv}>
                            <List>
                            <ListItem component={Link} button key={4} to='/' color="primary" onClick={() => handleSetOpen(false)}>
                                <ListItemIcon><HomeIcon /></ListItemIcon>
                                <ListItemText>Home</ListItemText>
                                </ListItem>
                            <ListItem component={Link} button key={1} to='/files' color="primary" onClick={() => handleSetOpen(false)}>
                                <ListItemIcon><FolderIcon /></ListItemIcon>
                                <ListItemText>Files</ListItemText>
                            </ListItem>
                            {addExternalUser &&
                                <ListItem component={Link} button key={2} to='/addexternaluser' color="primary" onClick={() => handleSetOpen(false)}>
                                    <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
                                    <ListItemText>Add External User</ListItemText>
                                </ListItem>
                            }
                            {addAccessRequest &&
                                <ListItem component={Link} button key={10} to='/accessrequest' color="primary" onClick={() => handleSetOpen(false)}>
                                    <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
                                    <ListItemText>Access Request</ListItemText>
                                </ListItem>
                            }
                              {addCompany &&
                                <ListItem component={Link} button key={11} to='/addcompany' color="primary" onClick={() => handleSetOpen(false)}>
                                    <ListItemIcon><BusinessIcon /></ListItemIcon>
                                    <ListItemText>Add Company</ListItemText>
                                </ListItem>

                            }
                             {/* {userfile &&
                                <ListItem component={Link} button key={12} to='/managerapproval' color="primary" onClick={() => handleSetOpen(false)}>
                                    <ListItemIcon><BusinessIcon /></ListItemIcon>
                                    <ListItemText>Manager Approval</ListItemText>
                                </ListItem>

                            } */}
                        </List>
                        {(addExternalUser || moderateFiles || userAdmin || manageCompanies || externalUserAdmin) &&
                            <React.Fragment>
                                <List>
                                    <ListItem button key={20} color="primary" onClick={() => setAdminMenuOpen(!adminMenuOpen)}>
                                        <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                                        <ListItemText>Administration</ListItemText>
                                        {adminMenuOpen ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                </List>
                                <Collapse in={adminMenuOpen} timeout="auto" unmountOnExit>
                                    <List>
                                        {moderateFiles &&
                                            <ListItem component={Link} button key={21} to='/moderatefiles' color='primary' className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                <ListItemIcon><VerifiedUserIcon /></ListItemIcon>
                                                <ListItemText>Moderate Files</ListItemText>
                                            </ListItem>
                                        }
                                        {userAdmin &&
                                            <React.Fragment>
                                                <ListItem component={Link} button key={22} to='/manageusers' color="primary" className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                    <ListItemIcon><PersonIcon /></ListItemIcon>
                                                    <ListItemText>Manage Users</ListItemText>
                                                </ListItem>
                                                <ListItem component={Link} button key={23} to='/manageaccessrequests' color="primary" className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                    <ListItemIcon><VpnKeyIcon /></ListItemIcon>
                                                    <ListItemText>Manage Access Requests</ListItemText>
                                                </ListItem>
                                                <ListItem component={Link} button key={24} to='/managenewcompanyrequests' color="primary" className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                    <ListItemIcon><BusinessIcon /></ListItemIcon>
                                                    <ListItemText>Manage New Company Requests</ListItemText>
                                                </ListItem>
                                            </React.Fragment>
                                        }
                                        {manageCompanies &&
                                            <ListItem component={Link} button key={25} to='/managecompanies' color="primary" className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                <ListItemIcon><BusinessIcon /></ListItemIcon>
                                                <ListItemText>Manage Companies</ListItemText>
                                            </ListItem>
                                        }
                                        {externalUserAdmin &&
                                            <ListItem component={Link} button key={26} to='/manageexternaluserrequests' color="primary" className={classes.nested} onClick={() => handleSetOpen(false)}>
                                                <ListItemIcon><PersonAddIcon /></ListItemIcon>
                                                <ListItemText>Manage External User Requests</ListItemText>
                                            </ListItem>
                                        }
                                    </List>
                                </Collapse>
                            </React.Fragment>
                        }
            
                {/* ===================== REPORTING (ADDED) ===================== */}
            
                <Divider />
            
             <List>
              <ListItem button key={30} color="primary" onClick={() => setReportMenuOpen(!reportMenuOpen)}>
                <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                <ListItemText>Reporting</ListItemText>
                {reportMenuOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </List>

            <Collapse in={reportMenuOpen} timeout="auto" unmountOnExit>
              <List>
                {userAdmin && (
                  <React.Fragment>
                    <ListItem
                      component={Link}
                      button
                      key={31}
                      to='/CompanyAccessReport'
                      color="primary"
                      className={classes.nested}
                      onClick={() => handleSetOpen(false)}
                    >
                      <ListItemIcon><PersonIcon /></ListItemIcon>
                      <ListItemText>Company Access Report</ListItemText>
                    </ListItem>

                    <ListItem
                      component={Link}
                      button
                      key={32}
                      to='/fileuploadreport'
                      color="primary"
                      className={classes.nested}
                      onClick={() => handleSetOpen(false)}
                    >
                      <ListItemIcon><VpnKeyIcon /></ListItemIcon>
                      <ListItemText>FileReport</ListItemText>
                    </ListItem>

                    <ListItem
                      component={Link}
                      button
                      key={33}
                      to='/loginreport'
                      color="primary"
                      className={classes.nested}
                      onClick={() => handleSetOpen(false)}
                    >
                      <ListItemIcon><VpnKeyIcon /></ListItemIcon>
                      <ListItemText>LoginReport</ListItemText>
                    </ListItem>
                  </React.Fragment>
                )}
              </List>
            </Collapse> 
            {/* =================== END REPORTING (ADDED) =================== */}
                        
                        
                          </div>
                    </Drawer>
                </span>
            }
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(NavMenu);